import { MAP_TYPES } from '@deck.gl/carto';

const SOCIOECONOMIC_FEATURES_SOURCE_ID = 'socioeconomicFeaturesSource';

function source() {
  return {
    id: SOCIOECONOMIC_FEATURES_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        category, feature, labels
      FROM
        carto-dw-ac-cn5bemsi.shared.features AS features
    `,
  };
}

export default source;
